import React from 'react';
import { Table, Loader, Button } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import clsx from 'clsx';
import TableHeaderError from './TableHeaderError';

const TableHeader = ({
  children,
  className,
  error,
  headerId,
  headerText,
  isLoading,
  loaderButton,
  loaderSize = 'small',
  numberOfColumns,
}) => (
  <Table.Row className={clsx('aridhia-table-header-row', className)}>
    <Table.HeaderCell colSpan={numberOfColumns} className="z-5" {...error && { className: 'aridhia-table-error' }}>
      <div className="aridhia-table-header">
        {headerId && <FormattedMessage id={headerId} />}
        {headerText}
        {isLoading && !loaderButton && <Loader active inline size={loaderSize} />}
        {isLoading && loaderButton && <Button icon="circle outline" basic circular loading />}
        {error && <TableHeaderError error={error} />}
        {children}
      </div>
    </Table.HeaderCell>
  </Table.Row>
);

export default TableHeader;
